<template>
	<div class="DataView-atten">
		<iframe class="iframe" ref="iframe" :src="iframeSrc" frameborder="0"></iframe>
	</div>
</template>
<script>
import { GetLeaveOutBigScreenData, GetRealtimeUpdate } from '../api/modules/big-screen';
import { publicAssetUrl } from '@/utils/publicAssetUrl';
export default {
	data: () => {
		return {
			window: null, // iframe窗口对象
			timer: null, // 30秒/30分钟定时器
			realtimeTimer: null, // 实时接口定时器
			departmentId: '0',
			date: '',
			isAdmin: 0,
			nowDate: '',
		}
	},
	computed: {
		/** build:api 下须带 /ui 前缀。创建于 2026-08-12 */
		iframeSrc() {
			return publicAssetUrl('static/leaveOut/index.html');
		}
	},
	mounted() {
		// // 初始化部门ID
		// if (window.localStorage.user) {
		// 	var user = JSON.parse(window.localStorage.user)
		// 	this.departmentId = user.DepartmentId || '0'
		// } else {
		// 	const queryString = window.location.search
		// 	const urlParams = new URLSearchParams(queryString)
		// 	this.departmentId = urlParams.get('departmentId') || '99'
		// 	if (this.departmentId == '0') {
		// 		this.departmentId = '99'
		// 	}
		// }
		// if (this.departmentId == '0') {
		// 	const queryString = window.location.search
		// 	const urlParams = new URLSearchParams(queryString)
		// 	this.departmentId = urlParams.get('departmentId') || '99'
		// 	if (this.departmentId == '0') {
		// 		this.departmentId = '99'
		// 	}
		// }
		
		// 获取 URL 参数
		const queryString = window.location.search
		const urlParams = new URLSearchParams(queryString)
		this.departmentId = urlParams.get('departmentId') || '99'
		if (this.departmentId == '0') {
			this.departmentId = '99'
		}

		this.initWindow()
		this.$nextTick(() => {
			this.initData()
			this.startRealtimeCheck() // 启动实时接口轮询
		})
	},
	beforeDestroy() {
		// 组件销毁时清理定时器
		if (this.timer) clearTimeout(this.timer)
		if (this.realtimeTimer) clearInterval(this.realtimeTimer)
	},
	methods: {
		// 初始化iframe窗口
		initWindow() {
			if (this.$refs.iframe) {
				let iframe = this.$refs.iframe
				iframe.addEventListener('load', () => {
					this.window = iframe.contentWindow
					this.window.onSelectDate = this.onSelectDate
				})
			} else {
				setTimeout(() => {
					this.initWindow()
				}, 100)
			}
		},
		// 主数据接口，每30秒刷新一次，或被实时接口触发
		async initData() {
			if (!this.window) {
				setTimeout(() => {
					this.initData()
				}, 100)
				return
			}

			let temp = this.formateDate()
			if (!this.nowDate) {
				this.nowDate = temp
			} else if (this.nowDate != temp) {
				window.location.reload()
				return
			}

			// 清除之前的定时器
			if (this.timer) {
				clearTimeout(this.timer)
				this.timer = null
			}
			var params = {
				departmentId: this.departmentId,
				date: this.date,
				isAdmin: this.isAdmin,
			}

			// 请求接口数据
			GetLeaveOutBigScreenData(params).then(data => {
				if (data.success) {
					this.window.$LargeScreenData = data.response;
				} else {
					this.window.$LargeScreenData = null;
				}
			}).catch(e => {
				console.log('接口异常:', e)
			});

			// 设置30秒后再次刷新
			this.timer = setTimeout(() => {
				this.timer = null
				console.log('30秒定时器触发，刷新数据')
				this.initData()
			}, 30 * 1000)
		},
		// 实时接口轮询，每秒调用一次
		startRealtimeCheck() {
			if (this.realtimeTimer) clearInterval(this.realtimeTimer)
			this.realtimeTimer = setInterval(() => {
				this.checkRealtimeUpdate()
			}, 1000)
			console.log('实时接口轮询启动')
		},
		// 实时接口逻辑
		async checkRealtimeUpdate() {
			const params = {
				departmentId: this.departmentId
			}
			try {
				const res = await GetRealtimeUpdate(params)
				if (res.success && res.response) {
					this.initData()
				}
			} catch (e) {
				console.log('实时接口异常:', e)
			}
		},
		// 日期选择回调
		onSelectDate(val) {
			this.date = val
			console.log(121212)
			this.$nextTick(() => {
				this.initData()
			})
		},
		// 日期格式化
		formateDate(fmt = 'yyyy-mm-dd', date = '') {
			if (!date) {
				date = new Date()
			}
			try {
				if (typeof date == 'string') {
					date = date.replace(/-/g, '/').replace(/T/g, ' ')
					if (date.indexOf('/') == -1) {
						date = new Date(parseFloat(date))
					}
					date = new Date(date)
				} else if (typeof date == 'number') {
					date = new Date(date)
				}
			} catch (error) {
				console.log('时间格式化出错', error)
				date = new Date()
			}
			let ret
			let weak = (function (date) {
				let days = date.getDay()
				let weekArrTxt = [
					'星期天',
					'星期一',
					'星期二',
					'星期三',
					'星期四',
					'星期五',
					'星期六',
				]
				let weekArrTxt2 = [
					'周日',
					'周一',
					'周二',
					'周三',
					'周四',
					'周五',
					'周六',
				]
				return [weekArrTxt[days], weekArrTxt2[days]]
			})(date)
			const opt = {
				'y+': date.getFullYear().toString(),
				'm+': (date.getMonth() + 1).toString(),
				'd+': date.getDate().toString(),
				'H+': date.getHours().toString(),
				'M+': date.getMinutes().toString(),
				'S+': date.getSeconds().toString(),
				'W+': weak[0],
				'w+': weak[1],
			}
			for (let k in opt) {
				ret = new RegExp('(' + k + ')').exec(fmt)
				if (ret) {
					fmt = fmt.replace(
						ret[1],
						ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0')
					)
				}
			}
			return fmt
		},
	},
}
</script>
<style>
.DataView-atten {
	overflow: hidden;
	width: 100vw;
	height: 100vh;
}

.iframe {
	width: 100%;
	height: 100%;
}
</style>
